// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2FWz_","header":"ReportDetails_header__3DhFQ","title":"ReportDetails_title__13SnL","left":"ReportDetails_left__2TH1V"};